import styled from 'styled-components';
export const ScrollWrapper = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: ${({ $grow = true }) => ($grow ? 1 : 0)};
  flex-shrink: ${({ $shrink = true }) => ($shrink ? 1 : 0)};
  overflow-y: auto;
  position: relative;
  overflow: overlay;
  scrollbar-gutter: stable;
`;
